const themes = {
  amber: {
    // background: '#fee5e2',
    background: '#ffb1b1',
    color: '#333',
    colorSecondary: '#666',
    colorPrimary: '#f3465b',
    colorError: '#f72a2a',
    // headerBg: '#fa9899',
    headerBg: '#fff',
    // headerBg: '#ff6d6f',
    headerLogoFont: "'Ribeye', cursive",
    headerFg: '#fc4387',
    titleFont: "'McLaren'",
    paperBg: '#ffd8d8',
    // paperBg: '#ffc4c1',
    paperBorder: '',
    paperDividerBorder: '1.1px solid #f68071',
    cardBg: '#ffc8d1',
    // cardBg: '#ffd6cf',
    cardHoverBg: '#ffd8d8',
    // cardHoverBg: '#ffc4c1',
    badgeBg: '#07badd',
  },
  ocean: {
    background: '#f3fafb',
    color: '#333',
    colorSecondary: '#666',
    colorPrimary: '#00a9cf',
    colorError: '#f72a2a',
    headerBg: '#07badd',
    headerLogoFont: "'Courgette', cursive",
    headerFg: '#fff',
    titleFont: "'Chilanka', cursive",
    paperBg: '#ecf6f7',
    paperBorder: '1px solid #d9ebec',
    paperDividerBorder: '1.1px solid #d9ebec',
    cardBg: '#d9ebec',
    cardHoverBg: '#b7e3e8',
    badgeBg: '#f13d51',
  },
  dark: {
    background: '#212121',
    color: '#fff',
    colorSecondary: 'rgba(255, 255, 255, 0.7)',
    colorPrimary: '#90caf9',
    colorError: '#ff3939',
    headerBg: '#333333',
    headerLogoFont: "'Carter One', cursive",
    headerFg: '#fff',
    titleFont: '',
    paperBg: '#424242',
    paperBorder: '1px solid rgba(255, 255, 255, 0.12)',
    paperDividerBorder: '1.1px solid #aaa',
    cardBg: '#555',
    cardHoverBg: '#666',
    badgeBg: '#f50057',
  },
};

export default themes;
